import type { JSX } from 'react';
import { FormSection } from '@ksyos/design-system';
import type { BariPreNurseSpecialistMedScreeningReportData } from '@common/validation/customControls/bariPre/bariPreNurseSpecialistMedScreeningReport/types';
import { CheckboxGroupOld } from '@frontend/components/fields/CheckBoxGroup';
import { useProcessActivityEditContext } from '@frontend/utils';
import { BooleanRadioGroupFormGroup } from '../../processActivityFormGroupFields';

export function BariPreNurseSpecialistMedScreeningReportFamiliaireBelasting(): JSX.Element {
    const { data, errors, onChange } = useProcessActivityEditContext<BariPreNurseSpecialistMedScreeningReportData>();

    return (
        <FormSection title="Familiaire belasting">
            <BooleanRadioGroupFormGroup
                fieldKey="overgewicht"
                isRequired={true}
                label="Overgewicht"
                onChange={handleChangeOvergewicht}
                type="radio"
            />
            {data.overgewicht && (
                <CheckboxGroupOld
                    checkboxOptions={[
                        {
                            checked: data.overgewicht_bij_wie_options?.overgewicht_vader || false,
                            label: 'Vader',
                            onChange: async (value) => handleChangeOverwichtBijWieOptions('overgewicht_vader', value),
                        },
                        {
                            checked: data.overgewicht_bij_wie_options?.overgewicht_moeder || false,
                            label: 'Moeder',
                            onChange: async (value) => handleChangeOverwichtBijWieOptions('overgewicht_moeder', value),
                        },
                        {
                            checked: data.overgewicht_bij_wie_options?.overgewicht_broer_zus || false,
                            label: 'Broer/zus',
                            onChange: async (value) =>
                                handleChangeOverwichtBijWieOptions('overgewicht_broer_zus', value),
                        },
                    ]}
                    error={errors.get('overgewicht_bij_wie_options')}
                    hasErrors={errors.has('overgewicht_bij_wie_options')}
                    isRequired={true}
                    label="Bij wie"
                />
            )}
            <BooleanRadioGroupFormGroup
                fieldKey="hypertensie"
                isRequired={true}
                label="Hypertensie"
                type="radio"
            />
            <BooleanRadioGroupFormGroup
                fieldKey="hart_en_vaatziekten"
                isRequired={true}
                label="Hart- en vaatziekten"
                type="radio"
            />
            <BooleanRadioGroupFormGroup
                fieldKey="hartfalen"
                isRequired={true}
                label="Hartfalen"
                type="radio"
            />
            <BooleanRadioGroupFormGroup
                fieldKey="diabetes_mellitus"
                isRequired={true}
                label="Diabetes mellitus"
                type="radio"
            />
        </FormSection>
    );

    async function handleChangeOvergewicht(value: boolean | null): Promise<void> {
        return onChange(
            {
                overgewicht: value,
                overgewicht_bij_wie_options: {
                    overgewicht_broer_zus: null,
                    overgewicht_moeder: null,
                    overgewicht_vader: null,
                },
            },
            'overgewicht'
        );
    }

    function handleChangeOverwichtBijWieOptions(fieldKey: string, value: boolean): void {
        onChange(
            {
                overgewicht_bij_wie_options: {
                    ...data.overgewicht_bij_wie_options,
                    [fieldKey]: value || null,
                },
            },
            'overgewicht_bij_wie_options'
        );
    }
}
